import * as React from 'react';
import {
    FormatStringPropsType,
} from './types';

const FormatString : React.FC<FormatStringPropsType> = ( props : FormatStringPropsType ) => {
    let replacedString = props.formatString;

    const entries = Object.entries( props.replacementInfo );
    for ( const info of entries ) {
        replacedString = replacedString.replace( `{${ info[ 0 ] }}`, '' + info[ 1 ] );
    }

    return (
        <span>{ replacedString }</span>
    );
};

export { FormatString };
